import { useState, useEffect } from '@max/max';
/**
 * 倒计时 Hook
 * @param endTime 结束时间戳（毫秒）
 * @returns 返回格式为 "xx:xx:xx后到期" 的字符串或空字符串
 */
export const useCountdown = (endTime) => {
    const [countdownText, setCountdownText] = useState('');
    useEffect(() => {
        if (!endTime || endTime <= 0) {
            setCountdownText('');
            return;
        }
        // 立即计算一次
        const calculateCountdown = () => {
            const now = Date.now();
            const diffMs = endTime - now;
            if (diffMs <= 0) {
                setCountdownText('');
                return;
            }
            // 转换为秒
            const diffSeconds = Math.floor(diffMs / 1000);
            // 计算小时、分钟、秒
            const hours = Math.floor(diffSeconds / 3600);
            const minutes = Math.floor(diffSeconds % 3600 / 60);
            const seconds = diffSeconds % 60;
            // 格式化为 xx:xx:xx
            const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            setCountdownText(`${formattedTime}后到期`);
        };
        // 立即执行一次
        calculateCountdown();
        // 每秒更新一次
        const timer = setInterval(() => {
            calculateCountdown();
        }, 1000);
        return () => clearInterval(timer);
    }, [endTime]);
    return countdownText;
};
export default useCountdown;
